import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { connect } from "react-redux";
import { HeroImage } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "./styles.m.css";
import StoryMidPromotion from "../../storyMidContent";
import { isPremium } from "../../../../../data/story";
import { ScrollPercentage } from "react-scroll-percentage";
import { PGAdwithAd, VikatanResponsiveContainer } from "../../../../rows/ad-free";
import Media from "react-media";
import Icon from "../../../../atoms/icon";
import { humanizeDate } from "../../../../utils/time-format";
import { fetchvuuklegetCommentCount } from "../../../../../api";
import GooglePreference from "../../../../atoms/google-preference";
import { WebEngage, DeepBI } from "../../../../../../isomorphic/integrations";

import ResponsiveImageWithFallback from "../../../../atoms/responsive-image-with-fallback";

import { generateImageSources } from "../../../../utils/utils";
import VikatanPlusSpecialHeader from "../../../../rows/vikatan-plus-special-header";

function MagazineStory(props, data) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const renderFooterMagazine = get(props, ["renderFooterMagazine"], () => null);
  const GetStoryScrollPercentage = get(props, ["GetStoryScrollPercentage"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "headline"], () => null);
  const storySubHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const readMore = false;
  const story = get(props, ["story"], () => null);
  const collection = get(props, ["issueCollectionObj"], () => null);
  const cards = readMore ? (isPremium(story) ? [] : singleCard.slice(0, 1)) : singleCard;
  const cardLength = cards.length;
  const evAccess = get(props, ["evAccess"]);
  const storyType = get(props, ["story", "story-template"], () => null);
  const storyId = get(props, ["story", "id"], "");
  const [Percentage, setPercentage] = useState(0);
  const expandComments = get(props, ["expandComments"], () => null);
  const [commentsCount, setCommentsCount] = useState(null);
  const ElementBasedAd = get(props, ["config", "ElementBasedAd"], false);
  const AllStoriesFree = get(props, ["config", "AllStoriesFree"], false);
  const [showShare, setShowShare] = useState(false);
  const [isPlay, setisPlay] = useState(false);
  const [userType, setUserType] = useState("F");

  const storyImage = get(props, ["story", "hero-image-s3-key"], () => null);
  const AudioAvailable = get(props, ["story", "metadata", "story-attributes", "audiolength"]);

  const vikatanPlusSpecial = get(props, ["data", "magazineEntity", "id"]);
  const showCustomHeader = vikatanPlusSpecial === 82091;

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);

  useEffect(
    () => {
      if ((userType === "P" || userType === "T" || userType === "R") && evAccess === "ALLOW_ACCESS") {
        if (AudioAvailable) {
          const params =
            global && global.location && global.location.search && new URLSearchParams(global.location.search);

          if (params && params.get("play") === "true") {
            handlePlay();
          }
          WebEngage.Webplayer(story, "AudioMagazinePlayerView", collection);
          DeepBI.PingAudioplayer(story, "AudioMagazinePlayerView", collection);
        }
      }
    },
    [evAccess, userType, AudioAvailable]
  );

  useEffect(
    () => {
      GetStoryScrollPercentage(Percentage);
    },
    [Percentage]
  );

  useEffect(
    () => {
      if (props.currentPlayingStory && props.currentPlayingStory.id !== storyId) {
        setisPlay(false);
      } else {
        setisPlay(props.PlayAudio);
      }
    },
    [storyId, props]
  );

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  const adShow = isPremium(story) ? !readMore : true;

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handlePlay = () => {
    if (props.ClosePlayer) {
      props.setCurrentStory(story);
      props.setCurrentCollection(collection);
      props.setMiniPlayerVisibility(true); // Dispatching action to Redux
      props.setAudioplaying(true);
      setisPlay(true);
      props.setClosePlayer(false);
    } else {
      props.setCurrentStory(story);
      props.setCurrentCollection(collection);
      props.setMiniPlayerVisibility(true); // Dispatching action to Redux
      props.setAudioplaying(true);
      setisPlay(true);
    }
  };

  const handlePause = () => {
    props.setAudioplaying(false);
    setisPlay(false);
    // props.setCurrentStory(story);
  };

  return (
    <div className="page-content">
      {showCustomHeader && <VikatanPlusSpecialHeader />}
      <div className={`container`}>
        <Media query="(max-width:768px)">
          <div className="mobile">
            <PGAdwithAd
              adId={`Vikatan2023_Mobile_SP_TOP_320x100`}
              adSize={[[320, 100]]}
              minHeight={100}
              adDivId="div-ad-desk-3849069-5447784-0"
              class="ad-320x100"
              config={props.config}
            />
          </div>
        </Media>
      </div>
      <div className={`${styles["story-grid"]}`}>
        {renderSidebar(adShow)}
        <div className={styles["main-content"]}>
          <div>
            <article className={`${styles["story-body"]} js-story`}>
              <Breadcrumb subSection={section} config={props.config} />
              <ScrollPercentage>
                {({ percentage, ref }) => {
                  const percentageRound = percentage.toFixed(2) * 100;
                  if (percentageRound) {
                    setPercentage(percentageRound);
                  }
                  return (
                    <div ref={ref}>
                      <div className={`${styles["sticky-socialshare"]} hidden-mobile`}>
                        {!readMore && renderSocialMedia("", true)}
                      </div>
                      {!storyType || storyType !== "cartoon" ? (
                        <div>{renderHeaderCard("", true, true, false)}</div>
                      ) : (
                        <div>{renderHeaderCard("", true, true, true)}</div>
                      )}
                      {!storyType || storyType !== "cartoon" ? (
                        <p className={`subheadline-main ${styles["subheadline"]}`}>{storySubHeadline}</p>
                      ) : null}
                      <div className={styles["published-time-wrap"]}>
                        {story["first-published-at"] && (
                          <span className={styles["published"]}>
                            Published:
                            <time
                              className={styles.time}
                              dateTime={new Date(story["first-published-at"]).toISOString()}
                            >
                              {humanizeDate(story["first-published-at"], "relative")}
                            </time>
                          </span>
                        )}
                        {story["last-published-at"] && (
                          <span className={styles["updated"]}>
                            Updated:
                            <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                              {humanizeDate(story["last-published-at"], "relative")}
                            </time>
                          </span>
                        )}
                      </div>
                      {!storyType || storyType !== "cartoon" ? (
                        <div className={styles["hero-image-wrapper"]}>
                          <HeroImage story={props.story} />
                        </div>
                      ) : null}
                      <div className={styles["audio-share-wrapper"]}>
                        <div className={styles["audio-comments-share"]}>
                          <div>
                            <GooglePreference story={story} />
                          </div>
                          <div className={styles["box-div"]} onClick={scrollToComments}>
                            <Icon type="comment" />
                            <span>{commentsCount && commentsCount[storyId]}</span>
                            <span className="hidden-mobile">Comments</span>
                          </div>
                          <div
                            className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""}`}
                            onClick={handleShareClick}
                          >
                            <Icon type="socialshare" />
                            <span className="hidden-mobile">Share</span>
                          </div>
                        </div>
                        <div className={styles["social-share-wrapper"]}>
                          {showShare && !readMore && renderSocialMedia("", false)}
                        </div>
                      </div>
                      {evAccess === "ALLOW_ACCESS" && (userType === "P" || userType === "T" || userType === "R") ? (
                        AudioAvailable && (
                          <div className={`${styles["magazine-audio-section"]}`}>
                            <div className={`${styles["magazine-audio-wrapper"]}`}>
                              <ResponsiveImageWithFallback
                                className={styles["image-wrapper"]}
                                slug={storyImage}
                                metadata={{}}
                                alt={storyHeadline}
                                imgParams={{ auto: ["format", "compress"] }}
                                sources={generateImageSources(
                                  { aspectRatio: [4, 3], screenWidthCoverage: 0.34 },
                                  { aspectRatio: [4, 3], screenWidthCoverage: 0.12 }
                                )}
                                story={story}
                              />
                              <div className={styles["audio-content-section"]}>
                                {storyHeadline && <h2 className={styles["audio-headline"]}>{storyHeadline}</h2>}
                                <div className={styles["waves-play"]}>
                                  {" "}
                                  <img src="https://media.vikatan.com/vikatan/2024-07/7696b52c-698f-4fa7-9bab-5c51d7c10f11/audio-waves.png" />
                                  <div
                                    className={`${styles["audio-control-icons"]} hidden-desktop`}
                                    onClick={isPlay ? handlePause : handlePlay}
                                  >
                                    {isPlay ? (
                                      <Icon type="pause" className={`${styles["pause"]} ${styles["audio-icon"]}`} />
                                    ) : (
                                      <Icon type="play" className={`${styles["play"]} ${styles["audio-icon"]}`} />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div
                                className={`${styles["audio-control-icons"]} hidden-mobile`}
                                onClick={isPlay ? handlePause : handlePlay}
                              >
                                {isPlay ? (
                                  <Icon type="pause" className={`${styles["pause"]} ${styles["audio-icon"]}`} />
                                ) : (
                                  <Icon type="play" className={`${styles["play"]} ${styles["audio-icon"]}`} />
                                )}
                              </div>
                            </div>
                            <div className={`${styles["audio-note"]}`}>
                              Listen to Vikatan stories on our AI-assisted audio player
                            </div>
                          </div>
                        )
                      ) : (
                        <div />
                      )}
                      <div
                        className={
                          AllStoriesFree === true ? "" : evAccess !== "ALLOW_ACCESS" ? styles["story-card-wrapper"] : ""
                        }
                      >
                        {" "}
                        {cards &&
                          cards.map((card, index) => {
                            return (
                              <React.Fragment key={card.id}>
                                {AllStoriesFree === true &&
                                  ElementBasedAd === false && (
                                    <VikatanResponsiveContainer
                                      placement={"text-story"}
                                      adtype={parseInt(index + 1)}
                                      storyId={storyId}
                                      className="ad_300_250"
                                      story={story}
                                      config={props.config}
                                    />
                                  )}
                                {index === 1 && (
                                  <div>{index === 1 ? <StoryMidPromotion story={props.story} /> : null}</div>
                                )}
                                <StoryCard
                                  card={card}
                                  story={props.story}
                                  showCard={readMore}
                                  index={index}
                                  cardLength={cardLength}
                                  renderRelatedArticle={renderRelatedArticle}
                                  config={props.config}
                                />
                              </React.Fragment>
                            );
                          })}
                      </div>
                    </div>
                  );
                }}
              </ScrollPercentage>
              <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>
              {renderFooter(readMore)}
            </article>

            <div magazineCard={props.magazineCard}>{renderFooterMagazine()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any,
  metadata: PropTypes.shape({
    "reference-url": PropTypes.string
  })
});

MagazineStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  isAccessible: PropTypes.bool,
  relatedStories: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      story: story
    })
  ),
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  handleExpandStory: PropTypes.func,
  renderAudioCommentsSocialMedia: PropTypes.func,
  magazineCard: PropTypes.object,
  setMiniPlayerVisibility: PropTypes.bool,
  setCurrentCollection: PropTypes.object,
  setAudioplaying: PropTypes.bool,
  setClosePlayer: PropTypes.bool,
  enablePlayer: PropTypes.bool,
  PlayAudio: PropTypes.bool,
  storyImage: PropTypes.string,
  storyHeadline: PropTypes.string,
  setCurrentStory: PropTypes.object,
  ClosePlayer: PropTypes.bool,
  currentPlayingStory: PropTypes.shape()
};

function mapDispatchToProps(dispatch) {
  return {
    setMiniPlayerVisibility: isVisible => {
      dispatch({
        type: "SET_MINI_PLAYER_VISIBILITY",
        payload: isVisible
      });
    },
    setAudioplaying: isVisible => {
      dispatch({
        type: "AUDIO_PLAYING",
        payload: isVisible
      });
    },
    setCurrentStory: story => {
      dispatch({
        type: "CURRENT_STORY",
        payload: story
      });
    },
    setCurrentCollection: collection => {
      dispatch({
        type: "CURRENT_COLLECTION",
        payload: collection
      });
    },
    setClosePlayer: isVisible => {
      dispatch({
        type: "CLOSE_PLAYER",
        payload: isVisible
      });
    }
  };
}

function mapStateToProps(state) {
  return {
    data: get(state, ["qt", "data"]),
    enablePlayer: get(state, ["ShowPlayer"]),
    PlayAudio: get(state, ["PlayAudio"]),
    ClosePlayer: get(state, ["ClosePlayer"]),
    currentPlayingStory: get(state, ["CurrentStory"])
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MagazineStory);
